export default "__VITE_ASSET__DyO_ZZFi__"